import reducer, { eventsTypes } from './duck';
import './locales/index';

export { Prize } from './containers';

export const prizeModule = {
  reducer: reducer,
  eventsTypes: eventsTypes,
};
